export const LANGUAGE = {
  EN: 'EN',
  MN: 'MN',
  RU: 'RU',
};

export const LANGUAGE_FLAGS = {
  [LANGUAGE.EN]: require('../../assets/icons/gb.png'),
  [LANGUAGE.MN]: require('../../assets/icons/mne.png'),
  [LANGUAGE.RU]: require('../../assets/icons/ru.png'),
};

export const LANGUAGE_LABELS = {
  [LANGUAGE.EN]: 'English',
  [LANGUAGE.MN]: 'Crnogorski',
  [LANGUAGE.RU]: 'Русский',
};

export const languageOptions = [
  {
    lang: LANGUAGE.EN,
    label: LANGUAGE_LABELS[LANGUAGE.EN],
    still: true,
  },
  {
    lang: LANGUAGE.MN,
    label: LANGUAGE_LABELS[LANGUAGE.MN],
    still: true,
  },
  {
    lang: LANGUAGE.RU,
    label: LANGUAGE_LABELS[LANGUAGE.RU],
    still: true,
  },
];
